// extracted by mini-css-extract-plugin
module.exports = {"header":"inventory-item-sold_header__3pzSF","heading":"inventory-item-sold_heading__3u6Oe","filter-container":"inventory-item-sold_filter-container__1OVmD"};